module.exports = __webpack_public_path__ + "img/14.16800434.jpg";